import React, { useEffect, useState } from "react";
import { Route, Redirect } from "react-router-dom";
import { useLocation, useHistory } from "react-router-dom";
import { Grid } from "@material-ui/core";
import VerticalMenuBar from "../common/authLayout/VerticalMenuBar";
import notifications from "../common/Components/Notifications/Notification";
import HeaderNew from "../common/HeaderNew";
import { StudioPageChromeProvider } from "../common/StudioPageChromeContext";
import { StudioOrgBrandProvider } from "../common/StudioOrgBrandContext";
import { ProductMediaUploadProvider } from "../uploads/ProductMediaUploadContext";
import ReactGA from "react-ga4";
import { DialogHost } from "../pages/karkhana/ui/dialog";
import { isKarkhanaSupervisor, rememberArea, supervisorMayOpen } from "../helpers/karkhanaEnabled";
import KarkhanaFrame from "../pages/karkhana/shell/KarkhanaFrame";
import { analyticsPage, hasSecretInAddress } from "./analyticsPage";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}: any) => {
  const location = useLocation();
  const [mini, setMini] = useState(localStorage.getItem("mini") || false);

  let miniLocal = localStorage.getItem("mini") || "";
  let trackingId: any = process.env.REACT_APP_GTAG_MEASUREMENT_ID;
  // A page opened with a token in its address (/a/<token>, /orders/confirm/<token>, Zoho's ?confirm=) skips the
  // automatic first page view and sets page_location without the token, so GA never stores it; the page view
  // below reports the masked page. Config is sent once, on the first call.
  const hasSecret = hasSecretInAddress(window.location.pathname, window.location.search);
  const safeLocation = window.location.origin + analyticsPage(window.location.pathname, window.location.search);
  ReactGA.initialize(
    trackingId,
    hasSecret ? { gtagOptions: { send_page_view: false, page_location: safeLocation } } : undefined
  );
  let getUserResFinal: any = "";
  try {
    getUserResFinal = JSON.parse(localStorage.getItem("GetUserRes") || "null") || "";
  } catch {
    // A bad saved profile (e.g. the text "undefined") must not blank every page.
    localStorage.removeItem("GetUserRes");
  }
  useEffect(() => {
    if (isAuthProtected) rememberArea(location.pathname);
  }, [isAuthProtected, location.pathname]);

  useEffect(() => {
    const { origin, pathname, search } = window.location;
    const page = analyticsPage(pathname, search);
    ReactGA.send({
      hitType: "pageview",
      page,
      title: analyticsPage(pathname, "").replace("/", ""),
      ...(hasSecretInAddress(pathname, search) ? { location: origin + page } : {}),
    });
  }, []);

  const applySidebarLayout = (expanded: boolean) => {
    const shell = document.querySelector(".hkp-studio-app");
    const content = document.getElementById("contentCard") as HTMLElement | null;
    if (content) {
      content.style.marginLeft = "";
      content.style.width = "";
    }
    if (shell) {
      shell.classList.toggle("is-sidebar-expanded", expanded);
    }
  };

  useEffect(() => {
    applySidebarLayout(miniLocal === "true");
  }, [mini, miniLocal]);
  const menuBarIn = () => {
    localStorage.setItem("mini", "true");
    setMini(true);
    applySidebarLayout(true);
  };

  const menuBarOut = () => {
    localStorage.setItem("mini", "false");
    setMini(false);
    applySidebarLayout(false);
  };
  let auth: any = localStorage.getItem("authUser");
  let authUser: any = JSON.parse(auth) || "";
  let miniFlag =
    miniLocal !== undefined || miniLocal !== null || miniLocal !== " "
      ? miniLocal === "true"
        ? true
        : false
      : mini;
  return (
    <Route
      {...rest}
      render={(routeProps: any) => {
        if (isAuthProtected && !authUser) {
          return (
            <>
              <Redirect
                to={{ pathname: "/home", state: { from: location } }}
              />
            </>
          );
        } else if (
          isAuthProtected &&
          isKarkhanaSupervisor(authUser?.users?.role) &&
          !supervisorMayOpen(location?.pathname)
        ) {
          // Supervisors only have the daily rounds; the server refuses everything else too.
          return <Redirect to="/karkhana" />;
        } else {
          return (
            <React.Fragment>
              <Layout>
                {isAuthProtected ? (
                  <StudioOrgBrandProvider>
                  <Grid container className={`darkContain hkp-studio-app${miniFlag ? " is-sidebar-expanded" : ""}${isKarkhanaSupervisor(authUser?.users?.role) ? " is-karkhana-only" : location?.pathname?.startsWith("/karkhana") ? " is-karkhana-page" : ""}`}>
                    <Grid item className="studio-sidebar-slot">
                      <VerticalMenuBar
                        {...routeProps}
                        mini={miniFlag}
                        menuBarIn={menuBarIn}
                        menuBarOut={menuBarOut}
                      />
                      <div
                        className={miniFlag ? "sideArrow1" : "sideArrow"}
                        onClick={() => {
                          if (miniFlag) {
                            menuBarOut();
                          } else {
                            menuBarIn();
                          }
                        }}
                      >
                        {miniFlag ? (
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 8 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.18848 10.4819L1.75006 6.04341L6.18848 1.605"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        ) : (
                          <svg
                            width="20"
                            height="20"
                            viewBox="0 0 8 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M1.78125 1.60498L6.21966 6.04344L1.78125 10.4819"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                            />
                          </svg>
                        )}
                      </div>
                    </Grid>
                    <Grid item xs={12} id="contentCard">
                      <StudioPageChromeProvider>
                        <ProductMediaUploadProvider>
                        <HeaderNew
                          {...routeProps}
                          getUserDetailsFromAPI={getUserResFinal}
                        />
                        <DialogHost />
                        <div className="hkp-studio-main">
                          {location?.pathname?.startsWith("/karkhana") ? (
                            <KarkhanaFrame>
                              <Component {...routeProps} />
                            </KarkhanaFrame>
                          ) : (
                            <Component {...routeProps} />
                          )}
                        </div>
                        </ProductMediaUploadProvider>
                      </StudioPageChromeProvider>
                    </Grid>
                  </Grid>
                  </StudioOrgBrandProvider>
                ) : (
                  <Grid item xs={12}>
                    <Component {...routeProps} />
                  </Grid>
                )}
              </Layout>
            </React.Fragment>
          );
        }
      }}
    />
  );
};

export default AppRoute;
